__turbopack_context__.v({
  "cursorImg": "ProgressPhotosSlider-module-scss-module__TD27_a__cursorImg",
  "gradient": "ProgressPhotosSlider-module-scss-module__TD27_a__gradient",
  "nav": "ProgressPhotosSlider-module-scss-module__TD27_a__nav",
  "nav__counter": "ProgressPhotosSlider-module-scss-module__TD27_a__nav__counter",
  "photos": "ProgressPhotosSlider-module-scss-module__TD27_a__photos",
  "slideInner": "ProgressPhotosSlider-module-scss-module__TD27_a__slideInner",
  "slideInner_desktop": "ProgressPhotosSlider-module-scss-module__TD27_a__slideInner_desktop",
  "swiper": "ProgressPhotosSlider-module-scss-module__TD27_a__swiper",
  "swiperSlide": "ProgressPhotosSlider-module-scss-module__TD27_a__swiperSlide",
});
